import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    Category,
    Content,
    ContentDetails,
    ReceivedGift,
    ResumeContent,
} from "JS/Models";
import {
    AudioVideoResume,
    PlayedAudiosVideos,
} from "JS/Models/Firebase/Resume";
import moment from "moment";

export interface VideoState {
    catagoriesList?: Category[];
    videosList?: Content[];
    videoDetails?: ContentDetailsMap;
    resumeVideos?: ResumeVideosMap;
    playedVideos: PlayedVideosMap;
    isUpdateRequired?: boolean;
    cacheTime?: number;
}

export type ContentDetailsMap = {
    [key: string]: ContentDetails;
};

export type PlayedVideosMap = {
    [key: string]: (Content | ReceivedGift | PlayedAudiosVideos)[];
};

export type ResumeVideosMap = {
    [key: string]: (ResumeContent | AudioVideoResume)[];
};

const initialState: VideoState = {
    catagoriesList: [],
    videosList: [],
    videoDetails: {},
    playedVideos: {},
    resumeVideos: {},
    isUpdateRequired: undefined,
    cacheTime: 0,
};

export const videoStateSlice = createSlice({
    name: "videoState",
    initialState,
    reducers: {
        setGlobalVideos: (state, data: PayloadAction<VideoState>) => {
            state.catagoriesList = data.payload.catagoriesList;
            state.videosList = data.payload.videosList;
            state.playedVideos = data.payload.playedVideos;
            state.isUpdateRequired = undefined;
            state.cacheTime = moment().unix() + 5000; // to adjust for time differences between server side and client side
            return state;
        },
        setGlobalUserResumeVideos: (
            state,
            data: PayloadAction<ResumeVideosMap>,
        ) => {
            state = { ...state, resumeVideos: data.payload };
            return state;
        },
        setGlobalPlayedVideos: (
            state,
            data: PayloadAction<PlayedVideosMap>,
        ) => {
            state = { ...state, playedVideos: { ...data.payload } };
            return state;
        },
        resetVideoState: () => initialState,
        setVideoDetails: (state, data: PayloadAction<ContentDetailsMap>) => {
            return { ...state, videoDetails: data.payload };
        },
    },
});

export const {
    setGlobalVideos,
    setGlobalPlayedVideos,
    resetVideoState,
    setGlobalUserResumeVideos,
    setVideoDetails,
} = videoStateSlice.actions;
